import React, { useRef, useEffect, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const STAR_COUNT = 2000;

export function MyStars2() {
  const meshRef = useRef();
  const tempObject = new THREE.Object3D();

  useFrame(() => {
    meshRef.current.rotation.y -= 0.0005;
  });
  useEffect(() => {
    for (let i = 0; i < STAR_COUNT; i++) {
      tempObject.position.set(
        Math.random() * 800 - 400,
        Math.random() * 800 - 400,
        Math.random() * 800 - 400
      );
      tempObject.updateMatrix();
      meshRef.current.instanceId = i;
      meshRef.current.setMatrixAt(i, tempObject.matrix);
      meshRef.current.instanceMatrix.needsUpdate = true;
    }
  }, []);

  return (
    <instancedMesh ref={meshRef} args={[null, null, STAR_COUNT]}>
      <sphereBufferGeometry attach="geometry" args={[0.7, 32, 16]} />
      <meshStandardMaterial
        attach="material"
        color="gold"
        transparent={true}
        opacity={0.8}
        emissive="gold"
      />
    </instancedMesh>
  );
}
export default MyStars2;
